import React from "react";
import { PageTitle, ParaTitle, ParaSubtitle, CodeSnippet, Pagination } from "../common";
import { Paragraph } from "../common";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ReusableTable from "../common/ReusableTable/ReusableTable";

const Home = () => {
  const applicationPermissioinsTable = {
    columns: [
      { id: 'permissions', label: 'Permissions' },
      { id: 'user', label: 'User' },
      { id: 'reviewer', label: 'Reviewer' },
      { id: 'riskManager', label: 'Risk Manager' },
      { id: 'approver', label: 'Approver' },
      { id: 'orgManager', label: 'Organization Manager' },
    ],
    data: [
      { permissions: 'Dashboard', user: 'X', reviewer: 'X', riskManager: 'X', approver: 'X', orgManager: 'X' },
      { permissions: 'Personal Settings (name, email, phone)', user: 'X', reviewer: 'X', riskManager: 'X', approver: 'X', orgManager: 'X' },
      { permissions: 'Change Own Password', user: 'X', reviewer: 'X', riskManager: 'X', approver: 'X', orgManager: 'X' },
      { permissions: 'Two-factor Authentication', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permissions: 'Reports', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
    ]
  };

  const administrationTable = {
    columns: [
      { id: 'permissions', label: 'Permissions' },
      { id: 'user', label: 'User' },
      { id: 'reviewer', label: 'Reviewer' },
      { id: 'riskManager', label: 'Risk Manager' },
      { id: 'approver', label: 'Approver' },
      { id: 'organizationManager', label: 'Organization Manager' },
    ],
    data: [
      { permissions: 'View Users', user: '', reviewer: 'X', riskManager: '', approver: '', organizationManager: 'X' },
      { permissions: 'Create/Edit Users', user: '', reviewer: 'X', riskManager: '', approver: '', organizationManager: 'X' },
      { permissions: 'Change User\'s Password', user: '', reviewer: 'X', riskManager: '', approver: '', organizationManager: 'X' },
      { permissions: 'Change User\'s Role', user: '', reviewer: 'X', riskManager: '', approver: '', organizationManager: 'X' },
      { permissions: 'Delete Users', user: '', reviewer: 'X', riskManager: '', approver: '', organizationManager: 'X' },
      { permissions: 'View Facilities', user: '', reviewer: '', riskManager: '', approver: '', organizationManager: 'X' },
      { permissions: 'Create Facilities', user: '', reviewer: '', riskManager: '', approver: '', organizationManager: 'X' },
      { permissions: 'Edit Facilities', user: '', reviewer: '', riskManager: '', approver: '', organizationManager: 'X' },
      { permissions: 'Delete Facilities', user: '', reviewer: '', riskManager: '', approver: '', organizationManager: 'X' },
    ],
  }
  const eventStatusDraftTable = {
    columns: [
      { id: 'permissions', label: 'Permissions' },
      { id: 'user', label: 'User' },
      { id: 'reviewer', label: 'Reviewer' },
      { id: 'riskManager', label: 'Risk Manager' },
      { id: 'approver', label: 'Approver' },
      { id: 'organizationManager', label: 'Organization Manager' },
    ],
    data: [
      { permissions: 'Create Event Draft', user: 'X', reviewer: 'X', riskManager: 'X', approver: 'X', organizationManager: 'X' },
      { permissions: 'Edit Own Draft', user: 'X', reviewer: 'X', riskManager: 'X', approver: 'X', organizationManager: 'X' },
      { permissions: 'Delete Own Draft', user: 'X', reviewer: 'X', riskManager: 'X', approver: 'X', organizationManager: 'X' },
      { permissions: 'Submitting Own Draft', user: 'X', reviewer: 'X', riskManager: 'X', approver: 'X', organizationManager: 'X' },
    ],
  }

  const eventStatusNewTable = {
    columns: [
      { id: 'permissions', label: 'Permissions' },
      { id: 'user', label: 'User' },
      { id: 'reviewer', label: 'Reviewer' },
      { id: 'riskManager', label: 'Risk Manager' },
      { id: 'approver', label: 'Approver' },
      { id: 'organizationManager', label: 'Organization Manager' },
    ],
    data: [
      { permissions: 'Review Event', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Assign Reviewer', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Upload Files', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Delete Files', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Request Approval', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Add/view comments', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Link Event', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
    ],
  }
  const eventStatusUnderReviewTable = {
    columns: [
      { id: 'permissions', label: 'Permissions' },
      { id: 'user', label: 'User' },
      { id: 'reviewer', label: 'Reviewer' },
      { id: 'riskManager', label: 'Risk Manager' },
      { id: 'approver', label: 'Approver' },
      { id: 'organizationManager', label: 'Organization Manager' },
    ],
    data: [
      { permissions: 'Review Event', user: '', reviewer: 'X', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Assign Reviewer', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Unassign Reviewer', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Close Review', user: '', reviewer: 'X', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Upload Files', user: '', reviewer: 'X', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Delete Files', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Add/view comments', user: '', reviewer: 'X', riskManager: 'X', approver: '', organizationManager: 'X' },
      { permissions: 'Link Event', user: '', reviewer: '', riskManager: 'X', approver: '', organizationManager: 'X' },
    ],
  }
  const eventStatusReviewCompletedTable = {
    columns: [
      { id: 'permission', label: 'Permissions' },
      { id: 'user', label: 'User' },
      { id: 'reviewer', label: 'Reviewer' },
      { id: 'riskManager', label: 'Risk Manager' },
      { id: 'approver', label: 'Approver' },
      { id: 'orgManager', label: 'Organization Manager' },
    ],
    data: [
      { permission: 'Review Event', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Assign Reviewer', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Reassign Reviewer', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Request Approval', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Upload Files', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Delete Files', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Add/View Comments', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Link Event', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
    ],
  }
  const eventStatusPendingApprovalTable = {
    columns: [
      { id: 'permission', label: 'Permissions' },
      { id: 'user', label: 'User' },
      { id: 'reviewer', label: 'Reviewer' },
      { id: 'riskManager', label: 'Risk Manager' },
      { id: 'approver', label: 'Approver' },
      { id: 'orgManager', label: 'Organization Manager' },
    ],
    data: [
      { permission: 'Approve Event', user: '', reviewer: '', riskManager: '', approver: 'X', orgManager: '' },
      { permission: 'Reject Event', user: '', reviewer: '', riskManager: '', approver: 'X', orgManager: '' },
      { permission: 'Upload Files', user: '', reviewer: '', riskManager: '', approver: '', orgManager: '' },
      { permission: 'Delete Files', user: '', reviewer: '', riskManager: '', approver: '', orgManager: '' },
      { permission: 'Add/View Comments', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Link Event', user: '', reviewer: '', riskManager: '', approver: '', orgManager: '' },
    ],
  }
  const eventStatusApprovalRejectedTable = {
    columns: [
      { id: 'permission', label: 'Permissions' },
      { id: 'user', label: 'User' },
      { id: 'reviewer', label: 'Reviewer' },
      { id: 'riskManager', label: 'Risk Manager' },
      { id: 'approver', label: 'Approver' },
      { id: 'orgManager', label: 'Organization Manager' },
    ],
    data: [
      { permission: 'Review Event', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Assign Reviewer', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Upload Files', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Delete Files', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Request Approval', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Add/view comments', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Link Event', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
    ],
  }
  const eventStatusClosedEventTable = {
    columns: [
      { id: 'permission', label: 'Permissions' },
      { id: 'user', label: 'User' },
      { id: 'reviewer', label: 'Reviewer' },
      { id: 'riskManager', label: 'Risk Manager' },
      { id: 'approver', label: 'Approver' },
      { id: 'orgManager', label: 'Organization Manager' },
    ],
    data: [
      { permission: 'View Closed Events', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
      { permission: 'Add/view comments', user: '', reviewer: '', riskManager: 'X', approver: '', orgManager: 'X' },
    ],
  }

  return (
    <div>
      <PageTitle title='SafetyNet Tutorial' role='' />
      <ParaTitle paraTitle='Welcome' />
      <Paragraph paragraph='This page is intended to cover the details of the SafetyNet, an application for managing the workflow of reporting incidents at healthcare facilities.' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        To understand your role's capabilities, look at the permissions outlined in the tables below. For other role information check out the <Link to='/roles'>Roles</Link> page. And if you're completely new it is strongly advised to read the <Link to='/general/events-summary'>General</Link> section of the tutorial. Otherwise every feature is described in the side bar menu on the left.
      </Typography>
      <Paragraph paragraph='' />
      <Paragraph paragraph='' />
      <ParaTitle paraTitle='Application Permissions:' />
      <ReusableTable tableConfig={applicationPermissioinsTable} />
      <ParaTitle paraTitle='Administration:' />
      <ReusableTable tableConfig={administrationTable} />
      <ParaTitle paraTitle='Event Permissions:' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        If you're unfamiliar with event statuses and how they work then strongly consider reading about them in the <Link to='/general/event-status'>Event Statuses</Link> page.
      </Typography>

      <ParaSubtitle paraSubtitle='Events, All Statuses:' />
      <Paragraph paragraph='All roles, except for the user, have access to Event Summary' />


      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        A <CodeSnippet codeSnippet='Draft' /> is created when a <i>User</i> creates an event but doesn't submit it.
      </Typography>

      <ParaSubtitle paraSubtitle='Event Status: Draft' />
      <ReusableTable tableConfig={eventStatusDraftTable} />

      <ParaSubtitle paraSubtitle='Event Status: New' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Submitting a draft changes the event status from <CodeSnippet codeSnippet='Draft' /> to <CodeSnippet codeSnippet='New' />
      </Typography>
      <ReusableTable tableConfig={eventStatusNewTable} />

      <ParaSubtitle paraSubtitle='Event Status: Under Review' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Assigning a <i>reviewer</i> changes the event status from <CodeSnippet codeSnippet='New' /> to <CodeSnippet codeSnippet='Under Review' />
      </Typography>
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        An event will be <CodeSnippet codeSnippet='Under Review' /> as long as there is a <i>reviewer</i> assigned to the event. Unassigning all <i>reviewers</i> will send an event back to  <CodeSnippet codeSnippet='New' /> while closing all reviews will set it to <CodeSnippet codeSnippet='Review Completed' />.
      </Typography>
      <ReusableTable tableConfig={eventStatusUnderReviewTable} />

      <ParaSubtitle paraSubtitle='Event Status: Review Completed' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        All <i>reviewers</i> have completed their reviews.
      </Typography>
      <ReusableTable tableConfig={eventStatusReviewCompletedTable} />

      <ParaSubtitle paraSubtitle='Event Status: Pending Approval' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Request approval is needed to change the status to <CodeSnippet codeSnippet='Pending Approval' />.
      </Typography>
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        <i>Approvers</i> can either approved or reject the event. Approval closes event and rejection sends it back to <i>Risk Manager</i>.
      </Typography>
      <ReusableTable tableConfig={eventStatusPendingApprovalTable} />

      <ParaSubtitle paraSubtitle='Event Status: Approval Rejected' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Events in this status have been rejected by an <i>Approver</i> and sent back to the <i>Risk Manager</i>.
      </Typography>
      <ReusableTable tableConfig={eventStatusApprovalRejectedTable} />

      <ParaSubtitle paraSubtitle='Event Status: Closed Event' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Event has been approved by the <i>Approver</i> and it is now archived. Only comments can be added at this point.
      </Typography>
      <ReusableTable tableConfig={eventStatusClosedEventTable} />

      <Pagination
        pagination={{
          next: { name: 'Updates: 3.55.0', link: '/updates/3.55.0' },
        }}
      />
    </div>
  );
};

export default Home;